import { Typography, Grid, Box } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import KenButton from "../../../../GlobalComponents/KenButton";
import { useStyles } from "../../style";
import { PDFDocument, rgb } from "pdf-lib";
import { degrees, StandardFonts } from "pdf-lib";
import { getBasicProfileSetting } from "../../../../Utils/apiService";
import { AuthContext } from "../../../../Helpers/Contexts/authContext";
import { AuthUser } from "../../../../interfaces/Contexts";
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: '90%', sm: '450px' },
  maxWidth: '450px',
  bgcolor: "background.paper",
  border: "2px solid white",
  boxShadow: 24,
  borderRadius: 2,
  p: { xs: 1.5, sm: 2 },
  overflowY: "auto",
  maxHeight: { xs: '90vh', sm: '80vh' }
};

const IdCard = (props: any) => {
  const classes = useStyles();
 
  return (
    <div>
      <Box sx={style}>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <Typography sx={{ fontSize: "13px", fontWeight: "500" }}>
              ID Card
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            style={{ display: "flex", justifyContent: "end", cursor: "pointer" }}
          >
            <CloseIcon onClick={props.handleClose} sx={{ fontSize: "15px" }} />
          </Grid>
        </Grid>
        <hr style={{ border: "1px solid #E6E6E8" }} />

        {/* Display PDF Preview */}
        <Box sx={{ height: { xs: "40vh", sm: "26vh" }, overflow: "hidden" }}>
          {props?.IdCardData ? (
            <iframe
              src={props?.IdCardData}
              title="ID Card Preview"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            ></iframe>
          ) : (
            <Typography>Loading ID Card...</Typography>
          )}
        </Box>
        <Box sx={{ 
          display: "flex", 
          justifyContent: "center",
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 1, sm: 2 },
          mt: { xs: 1, sm: 2 }
        }}>
          <KenButton
            variant="text"
            className={classes.button}
            sx={{
              borderRadius: "8px",
              fontWeight: "500",
              backgroundColor: "none",
              "&:hover": {
                backgroundColor: "transparent",
              },
              color: "black",
              width: { xs: '100%', sm: 'auto' }
            }}
            onClick={props.handleClose}
            fullWidth
          >
            <Typography sx={{ fontSize: { xs: "11px", sm: "12px" }, fontWeight: "500", color: "#373A45" }}>
              Cancel
            </Typography>
          </KenButton>

          {props?.IdCardData && (
            <KenButton
              variant="contained"
              className={classes.button}
              sx={{
                borderRadius: "7px",
                boxShadow: "none",
                "&:hover": {
                  boxShadow: "none",
                },
                width: { xs: '100%', sm: 'auto' }
              }}
              fullWidth
            >
              <Typography
                sx={{ fontSize: { xs: "11px", sm: "12px" }, fontWeight: "500" }}
                onClick={() => {
                  const link = document.createElement("a");
                  link.href = props?.IdCardData;
                  link.download = "filled_certificate.pdf";
                  link.click();
                }}
              >
                Download
              </Typography>
            </KenButton>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default IdCard;
